// extracted by mini-css-extract-plugin
export default {"headerTitle":"components_headerTitle__++BCo","desc":"components_desc__qQnIR","applyLog":"components_applyLog__jVCtJ","danger":"components_danger__JA1qz"};